// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sid-request-dl dt{margin-bottom:5px;color:#4d4d4d}.sid-request-dl dd{padding:4px;margin-bottom:15px;color:#000;background:linear-gradient(90deg, #edf7f7, white)}", ""]);
// Exports
module.exports = exports;
